import React from "react"
import "./accordion.scss"

const Accordion = ({ props }) => {

    // let seoData = {
    //     "@context": "https://schema.org",
    //     "@type": "FAQPage",
    //     mainEntity: contents.map((item, index) => {
    //         return{
    //             "@type": "Question",
    //             name: item.Question,
    //             acceptedAnswer: {
    //                 "@type": "Answer",
    //                 text: item.Answer,
    //             } 
    //         }
    //     })
    // }

    return (
        <>
            <div className="faq-container">
                <div className="uk-card uk-card-muted">
                    {/* <script type="application/ld+json">{JSON.stringify(seoData)}</script> */}
                    {
                        props.title ?
                            <div>
                                <h2 className="uk-text-center">{props.title}</h2>
                            </div>
                            : ""
                    }
                    <div data-uk-accordion className=" faq-accordion">
                        {
                            props.contents.map((item, index) => {
                                return (
                                    <li key={index}>
                                        <a className="uk-accordion-title faq-question" href="#0">
                                            {item.Question}
                                        </a>
                                        <div className="uk-accordion-content faq-answer">
                                            <p>{item.Answer}</p>
                                            {((item.URL)?.length > 0) ?
                                                <a href={`/news/${item.URL}`} className="accordion-answer-read-more"
                                                    //target="_blank"
                                                >Learn more about this</a>
                                                : ''
                                            }
                                        </div>
                                    </li>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default Accordion